export default __webpack_public_path__ + "static/media/excellent.89f4a2d1.svg";